










import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'
import AuthMixin from '@/mixins/AuthMixin.vue'

@Component
export default class QuantityTypeSelector extends Mixins(AuthMixin) {
  @Prop({ type: String, default: "" })
  public selectedCategory!: string

  @Prop({ type: String, default: "" })
  public selectedQuantityType!: string

  @Prop({ type: String, default: "See order comments" })
  public commentOption!: string

  private _quantityType = ""

  public beerTypes = [
    "6 pack",
    "12 pack",
    "Case (18oz 15 pack)",
    "Case (500mL 20 pack)",
    "Case (12oz 24 pack)",
    "Case (16oz 24 pack)",
    "Keg (5.16 gallon)",
    "Keg (5.2 gallon)",
    "Keg (7.75 gallon)",
    "Keg (15.5 gallon)",
    this.commentOption
  ]
  public liquorTypes = [
    "750mL",
    "Liter",
    "1.75L",
    "Case - 6",
    "Case - 12",
    this.commentOption
  ]
  public wineTypes = [
    "750mL",
    "Liter",
    "Case - 6",
    "Case - 12",
    this.commentOption
  ]
  public bittersAndCocktailMixTypes = [
    "Case - 6",
    "Case - 12",
    this.commentOption
  ]
  public waterTypes = [
    "500 ml",
    "750 ml",
    "Case (500mL)",
    "Case (750mL)",
    this.commentOption
  ]

  public set quantityType(quantityType: string) {
    this._quantityType = quantityType
    this.updateQuantityTypeSelection(quantityType)
  }

  public get quantityType() {
    return this._quantityType || this.selectedQuantityType
  }

  get quantityTypes() {
    if(!this.selectedCategory) {
      return [this.commentOption]
    }

    if(this.selectedCategory === "Food, Beverages & Tobacco > Beverages > Alcoholic Beverages > Beer") {
      return this.beerTypes
    } else if(this.selectedCategory.includes("Liquor & Spirits")) {
      return this.liquorTypes
    } else if(this.selectedCategory.includes("Wine")) {
      return this.wineTypes
    } else if(this.selectedCategory.includes("Bitters")){
      return this.bittersAndCocktailMixTypes
    } else if(this.selectedCategory.includes("Cocktail Mixes")){
      return this.bittersAndCocktailMixTypes
    } else if(this.selectedCategory.includes("Hard Cider")){
      return this.beerTypes
    } else if(this.selectedCategory.includes("Flavored Alcoholic Beverages")){
      return this.beerTypes
    } else if(this.selectedCategory.includes("Water")){
      return this.waterTypes
    } else {
      return [this.commentOption]
    }
  }

  @Emit('updateQuantityTypeSelection')
  public async updateQuantityTypeSelection(quantityType: string) {
    return quantityType
  }
}
